export { PriceTag } from './PriceTag'
export type { PriceTagProps } from './types'
